/**
 * This file is part of Shuup.
 *
 * Copyright (c) 2012-2020, Shoop Commerce Ltd. All rights reserved.
 *
 * This source code is licensed under the OSL-3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import "babel-polyfill";
import "url-search-params-polyfill";
import "./language_changer.js";
import "./navigation.js";
import "./category.js";
import "./product_preview.js";
import "./update_price.js";
import "./custom.js";
import "./utils";
import "./dropzone.js"
